import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap, tap } from "rxjs/operators";

import { LOGGER } from "@hermes/core-web-logger";

import {
    fetchMenu,
    fetchMenuFailure,
    fetchMenuSuccess,
} from "../actions/menu.action";

import { MenuService } from "../services/menu.service";

@Injectable()
export class MenuEffects {
    private logger = inject(LOGGER);
    private actions$ = inject(Actions);
    private menuService = inject(MenuService);

    public fetchMenu$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchMenu),
            switchMap(() =>
                this.menuService.fetchMenuDatas().pipe(
                    map((response) => fetchMenuSuccess({ entry: response })),
                    catchError((error) => of(fetchMenuFailure({ error }))),
                ),
            ),
        ),
    );

    public fetchMenuFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchMenuFailure),
                tap(({ error }) =>
                    this.logger.error(
                        "Error when retrieving menu data from discovery",
                        error.message,
                    ),
                ),
            ),
        { dispatch: false },
    );
}
